const Colours = [
  "#556270", // MightySlate
  "#4ECDC4", // Pacifica
  "#C7F464", // AppleChic
  "#FF6B6B", // CheeryPink
  "#C44D58", // Grandma's Pillow
  "#69D2E7", // Aoi
  "#A7DBD8", // Clean Pondwater
  "#E0E4CC", // Beach Storm
  "#FA6900", // Unreal Food Pills
  "#00A0B0", // Invisible UFO
];

export default Colours;



// WEBPACK FOOTER //
// ./src/components/Charts/Colours.js